import PropTypes from "prop-types";
import {isObject} from "lib/ext/object";

function Input({type = "text", ...props}) {
  if(type === "select") {
    const {options = [], placeholder = null, ...selectProps} = props;

    return (
      <select {...selectProps}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          isObject(option) ? (
            <option key={option.value} value={option.value}>{option.name}</option>
          ) : (
            <option key={option} value={option}>{option}</option>
          )
        ))}
      </select>
    );
  }

  return <input type={type} {...props} />;
}

Input.propTypes = {
  children: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ]).isRequired
  ),
  placeholder: PropTypes.string,
  type: PropTypes.string
};

export default Input;
